import React, { useEffect } from "react";
import "../AdminPanel/AdminPanel.css";
import CRMModule from "../AdminPanel/tabs/CRM/CRMModule";

const CRMPanel = ({ userId, userProfile, setHeaderTitle }) => {
    useEffect(() => {
        setHeaderTitle("CRM Panel");
    }, []);

    return (
        <div className="admin-panel">
            <div className="admin-panel-header">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                <h1>CRM Panel</h1>
                <span className={`admin-role-badge ${userProfile === "superadmin" ? "superadmin" : ""}`}>
                    {userProfile}
                </span>
            </div>
            <div className="admin-table-wrapper">
                <CRMModule userProfile={userProfile} userId={userId} />
            </div>
        </div>
    );
};
 

export default CRMPanel;
 